const globalVar = {"data":[],"configData":[],"fonts":[]}
export default globalVar